export default __webpack_public_path__ + "static/media/T_Green.5c8ffa8c.png";